import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nb-root-container',
  templateUrl: './root-container.component.html',
  styleUrls: ['./root-container.component.scss'],
})
export class RootContainerComponent implements OnInit {
  constructor() {}
  ngOnInit() {}
}
